import React from 'react'
import { Text } from 'theme-ui'

import { SectionWrapperStyled, SectionContainerStyled, SectionHeadStyled, SectionContentStyled, SectionMediaStyled } from './styles'
import Section from './../Section/index'
import CardList from './../../organisms/CardList'
import { ServingYourTechProps } from './types'
import MediaItem from './../../molecules/MediaItem'

const ServingYourTechSection: React.FC<ServingYourTechProps> = ({
  id,
  heading,
  isHeadingGreen,
  subheading,
  description,
  bgColor,
  inner,
  paddingTop,
  paddingBottom,
  headingPadding,
  data
}) => {
  const { head, media, content } = data
  return (
    <Section
      {...{ id, inner, paddingTop, paddingBottom, headingPadding, bgColor, heading, isHeadingGreen, subheading, description, data }}
      body={
        <SectionWrapperStyled>
          {head && (
            <SectionHeadStyled>
              {head.title && (
                <Text
                  sx={{
                    variant: 'headingRaleway2',
                    fontFamily: 'secondary',
                    fontWeight: 'bold'
                  }}
                  as="h2"
                >
                  {head.title}
                </Text>
              )}
              {head.description && (
                <Text
                  sx={{
                    variant: 'headingMontserrat3',
                    marginTop: ['16px', '10px']
                  }}
                  as="p"
                >
                  {head.description}
                </Text>
              )}
            </SectionHeadStyled>
          )}
          <SectionContainerStyled>
            <SectionContentStyled>
              <CardList data={content} />
            </SectionContentStyled>
            {media && <SectionMediaStyled>{media.image || media.video ? <MediaItem {...{ media }} /> : ''}</SectionMediaStyled>}
          </SectionContainerStyled>
        </SectionWrapperStyled>
      }
    />
  )
}

export default ServingYourTechSection
